import { extractArrayFromQuery } from '@/utils/query';

export const ethnicityOptions = [
  'Native American / American Indian or Alaska Native',
  'Asian or Asian American',
  'Black or African American',
  'Hispanic or Latino',
  'Native Hawaiian or Other Pacific Islander',
  'White',
  'Multiracial',
  'Other',
  'Prefer Not to Say'
];
export function ethnicityValues(search) {
  if (!search || !search.ethnicities || !search.ethnicities.length) return undefined;
  const ethnicities = extractArrayFromQuery(search, 'ethnicities')
  return ethnicities.map(index => ethnicityOptions[index - 1])
}


export default {
  param: extractArrayFromQuery,
  query: function (values) {
    if (values.length > 0) {
      return {
        ethnicity: {
          $in: values.map(function(value) {
            return ethnicityOptions[Number(value) - 1];
          })
        }
      }
    }
  }
}
